<template lang="pug">
AppDialog.timesheet-confirm-dialog(
  title="Warning"
  append-to-body
  :show="show"
  @close="$emit('reject')"
)
  i.fa.fa-warning.warning-icon

  p(v-if="multipleSheets")
    | You are about to approve timesheets in the current pay period.
    br
    strong These members will not be able to track more time until tomorrow.

  p(v-else)
    | You are about to approve a timesheet in the current pay period.
    br
    strong This team member will not be able to track time until tomorrow.

  template(#footer)
    AppButton(@click="$emit('reject')")
      | Cancel

    AppButton(
      type="primary"
      @click="$emit('approve')"
    )
      | Approve anyway
</template>

<script>
export default {
  name: 'TimesheetApprovalsConfirmDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    multipleSheets: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
